import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { onMounted, ref, PropType } from 'vue'
import { IonContent } from '@ionic/vue'
import InlineSvg from 'vue-inline-svg'
import { useGwModal } from '@/plugins/gw-modal'
import { useGWAnalytics } from '@/plugins/analytics'
import { useGWAnalyticsBasePayload } from '@/plugins/analytics/composables/analyticsBasePayload'


export default /*#__PURE__*/_defineComponent({
  __name: 'GwBottomSheet',
  props: {
	canDismiss: { default: true, type: Boolean },
	cssClass: { default: '', type: String },
	data: { default: undefined, type: Object },
	fixedDismissButton: { default: true, type: Boolean },
	name: { default: 'Unknown modal', type: String },
	onClose: { default: undefined, type: Function as PropType<() => Promise<any>> },
	size: { default: 'sm', type: String }
},
  setup(__props) {

const props = __props;



const content = ref()
const { track } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const { closeTop } = useGwModal()
const close = async () => {
	try {
		track('click', {
			...payload.value,
			name: 'Close',
			page: props.name
		})
	} catch(err) {
		console.error(err)
	}
	if (props.onClose) await props.onClose()
	else closeTop()
}

onMounted(async () => {
	document.dispatchEvent(new CustomEvent('gwModalPresented', { detail: { page_name: props.name } }))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), {
    ref_key: "content",
    ref: content,
    class: "[--background:white] ![--keyboard-offset:0]"
  }, {
    default: _withCtx(() => [
      (props.canDismiss)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex justify-end w-screen left-0 pt-5 px-5 pb-2 z-10 rounded-2xl", { 'fixed': __props.fixedDismissButton, 'absolute': !__props.fixedDismissButton }])
          }, [
            _createElementVNode("button", {
              class: "w-8 h-8 rounded-full flex items-center justify-center bg-[#f3f3f3]",
              onClick: _withModifiers(close, ["prevent"])
            }, [
              _createVNode(_unref(InlineSvg), {
                src: require('@/assets/x-solid.svg'),
                class: "w-3 h-3 text-[#a3a3a3]"
              }, null, 8, ["src"])
            ], 8, _hoisted_1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-full px-1", { 'pt-5': !props.canDismiss, 'pt-[3.75rem]': props.canDismiss }])
      }, [
        _renderSlot(_ctx.$slots, "default", {
          content: content.value,
          data: __props.data
        })
      ], 2)
    ]),
    _: 3
  }, 512))
}
}

})